let themeObject = {};

document.addEventListener('DOMContentLoaded', function() {
    themeObject = {
        // TODO: Move these to the "selectors" object below
        addToCartBtn: document.querySelectorAll('[data-add-to-cart-button]'),
        checkoutBtn: document.querySelectorAll('.button--checkout'),
        filterBtn: document.querySelector('toggle-element-class[data-options=\'{"toggleClass": "modal-is-open"}\']'),
        headerDiv: document.querySelector('#shopify-section-header'),
        klaviyoBtn: document.querySelectorAll('.klaviyo-bis-trigger'),
        notAvailableBadges: document.querySelectorAll('.product__badge--not-available'),
        notAvailableMessageElements: document.querySelectorAll('.not-available-message'),
        notAvailableStockMessage: document.querySelectorAll('.not-available-message'),
        notificationMessageStock: document.querySelector('.sold-out-stock span'),
        productRelatedSection: document.querySelector('.product-related'),
        quickAddBtn: document.querySelectorAll('.product-card__quick-add'),
        soldOutBadges: document.querySelectorAll('.product__badge--sold-out'),
        soldOutStockElements: document.querySelectorAll('.sold-out-stock'),
        soldOutStockMessage: document.querySelector('.sold-out-stock'),

        // Selectors
        selectors: {
            euRedirectBtn: document.querySelectorAll( '.button-eu--redirect' ),
            inventoryAlerts: document.querySelectorAll( '.inventory-alerts' ),
            
            // Navigation
            nav: {
                headerMenuItems: document.querySelectorAll('.header__menu-item--level-1.header__menu-item--multi'),
                headerMenuItemsSelector: '.header__menu-item--level-1.header__menu-item--multi',
                headerMenuLink: '.header__menu-link',
                headerDropdownTarget: '[data-collapsible-target]',
                headerMenuItemIsOpen: 'header__menu-item--is-open',
            },
        },
        
        // Methods
        fetchLocalization: async function() {
            const response = await fetch(
                window.Shopify.routes.root
                + 'browsing_context_suggestions.json'
                + '?country[enabled]=true'
                + `&country[exclude]=${window.Shopify.country}`
                + '&language[enabled]=true'
                + `&language[exclude]=${window.Shopify.language}`
            );
            const data = await response.json();
            return data;
        }
    };
});
